import { useNavigate, useSearchParams } from "react-router-dom";
import { Divider, Grid, Typography } from "@mui/material";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/modifyWhatsAppTemplate.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import GlobalButton from "../../../utility/globalButton/button";
import { createBasicTemplateFromScratch, isInteractiveTemplate } from "../constant";
import { createWhatsappTemplatePayloadForTemplateLibrary } from "../../../../models/axiosModel";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";
import { useShallow } from "zustand/react/shallow";

const PostCreateTemplatePopup = () => {
    
    const navigate = useNavigate();
    
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const { postCreatePopup, closePostSubmitPopup, setCreateTemplatePayload, setExistingTemplateData, setExistingPayloadData, setTemplateStatus, setHasUnsavedChanges, templateLibraryCategoryList, whatsappTemplateButtonGenericData, createTemplatePayload } = useTemplateLibraryStore(
        useShallow((state) => ({
            postCreatePopup: state.postCreatePopup,
            closePostSubmitPopup: state.closePostSubmitPopup,
            setCreateTemplatePayload: state.setCreateTemplatePayload,
            setExistingTemplateData: state.setExistingTemplateData,
            setExistingPayloadData: state.setExistingPayloadData,
            setTemplateStatus: state.setTemplateStatus,
            setHasUnsavedChanges: state.setHasUnsavedChanges,
            templateLibraryCategoryList: state.templateLibraryCategoryList,
            whatsappTemplateButtonGenericData: state.whatsappTemplateButtonGenericData,
            createTemplatePayload: state.createTemplatePayload,
        }))
    );

    const isPostSubmitWasUpdate = postCreatePopup === 'update';
    const isPostSubmitInteractive = isInteractiveTemplate(createTemplatePayload);

    const postSubmitActionText = isPostSubmitInteractive
        ? `${isPostSubmitWasUpdate ? "updated" : "created"} and approved.`
        : (isPostSubmitWasUpdate ? "updated and sent" : "submitted");
    
        const postSubmitReviewClause = isPostSubmitInteractive ? "" : " to Meta for review. Approval may take some time.";

    const closePopup = closePostSubmitPopup;

    const handleStartFromScratch = () => {
        closePopup();
        
        const scratchPayload = createBasicTemplateFromScratch(
            templateLibraryCategoryList ?? [],
            whatsappTemplateButtonGenericData ?? []
        ) as createWhatsappTemplatePayloadForTemplateLibrary;
        
        setCreateTemplatePayload(scratchPayload);
        setExistingTemplateData(scratchPayload);
        setExistingPayloadData(scratchPayload);
        setTemplateStatus(null);
        setHasUnsavedChanges(false);
        
        navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}`, { replace: true });
    };

    const handleUseTemplateLibrary = () => {
        closePopup();
        navigate(`/channels/viewintegration/whatsapp/templatelibrary?id=${id}`);
    };

    const handleGoToTemplateList = () => {
        closePopup();
        navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`);
    };

    return (
        <Grid container direction={"column"} gap={"15px"} className={globalStyles.zIndex1}>
            
            {/* Title */}
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`} padding={"0px 30px 0px 30px"}>
                <Typography className={styles.popupTitleStyle}>
                    {isPostSubmitWasUpdate
                        ? "Template Updated"
                        : (isPostSubmitInteractive ? "Template Created" : "Template Submitted")}
                </Typography>
            </Grid>

            {/* Divider */}
            <Grid item padding={"0 30px 0 30px"}>
                <Divider className={styles.popupDividerStyle} />
            </Grid>

            {/* Body Text */}
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                <Grid container direction={"column"} padding={"0px 30px 5px 30px"} gap={"15px"}>
                    <Grid item>
                        <Typography className={styles.popupBodyTextStyle}>
                            {`Your template has been ${postSubmitActionText} ${postSubmitReviewClause} What would you like to do next?`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

            {/* Action Buttons */}
            <Grid item className={globalStyles.fullwidth} mt={2} padding={"0px 0px 30px 0px"}>
                <Grid container direction={"row"} className={styles.postCreatePopupActions}>
                    <Grid item>
                        <GlobalButton
                            buttonText="Go to List"
                            className="primaryButtonStyle"
                            onClick={handleGoToTemplateList}
                        />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText="Create From Scratch"
                            className="borderedButtonStyle"
                            onClick={handleStartFromScratch}
                        />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText="Use Library"
                            className="borderedButtonStyle"
                            onClick={handleUseTemplateLibrary}
                        />
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
};

export default PostCreateTemplatePopup;
